import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

interface PhaseMinutesInputProps {
  value: number | null;
  inherited?: boolean;
  onChange: (minutes: number | null) => void;
  label?: string;
}

export function PhaseMinutesInput({ value, inherited = false, onChange, label = "Phase time" }: PhaseMinutesInputProps) {
  const [draft, setDraft] = useState<string>(value != null ? String(value) : "");

  useEffect(() => {
    setDraft(value != null ? String(value) : "");
  }, [value]);

  const commit = () => {
    const trimmed = draft.trim();
    if (trimmed === "") {
      if (value != null) onChange(null);
      return;
    }
    const num = Number(trimmed);
    if (!Number.isFinite(num) || num < 0) {
      setDraft(value != null ? String(value) : "");
      return;
    }
    if (num !== value) onChange(num);
  };

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-xs text-muted-foreground">{label}</span>
      <Input
        type="number"
        inputMode="numeric"
        min={0}
        step={1}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") (e.target as HTMLInputElement).blur();
        }}
        placeholder={inherited ? "inherited" : "min"}
        title={inherited ? "Inherited from All Brands. Enter a value to override." : "Estimated minutes for this phase step"}
        className={`h-7 w-20 px-2 text-xs text-center ${inherited ? "text-muted-foreground border-dashed" : ""}`}
      />
      <span className="text-xs text-muted-foreground">min</span>
    </label>
  );
}
